import { Injectable } from '@angular/core';
import { File as IFile } from '@shared/api/api-loop/models/file';
import { getLinkExpirationDate, isLinkExpired } from '@shared/modules/files/common/helpers/link-helpers';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { FileDownloadService } from './file-download.service';

@Injectable()
export class BrowserFileDownloadService extends FileDownloadService {
  downloadFromArrayBuffer(
    arrayBuffer: ArrayBuffer,
    options?: { fileName?: string; mimeType?: string }
  ): Observable<void> {
    const blob = new Blob([arrayBuffer]);
    const downloadLink = window.URL.createObjectURL(blob);
    return this.downloadFromLink(downloadLink, options);
  }

  downloadFromLink(downloadLink: string, options?: { fileName?: string; mimeType?: string }): Observable<void> {
    const a = this.domDocument.createElement('a');
    a.href = downloadLink;
    a.target = '_blank';
    a.download = options?.fileName ?? 'download';
    this.domDocument.body.appendChild(a);
    a.tabIndex = -1;
    a.focus();
    a.click();
    this.domDocument.body.removeChild(a);
    return of(undefined);
  }

  downloadFile(file: IFile): Observable<void> {
    if (!file.urlLink || isLinkExpired(getLinkExpirationDate(file.urlLink))) {
      return this.fileApiService.File_GetFile({ id: file.id }).pipe(
        switchMap(file => {
          return this.downloadFromLink(file.urlLink, { fileName: file.name });
        })
      );
    }

    return this.downloadFromLink(file.urlLink, { fileName: file.name });
  }

  downloadFileToLocalPath$(_file: IFile): Observable<undefined> {
    // The web app has no local file system to download to
    return of(undefined);
  }

  downloadAllFiles(
    _fileNamesWithFileUris: { fileName: string; fileUri: string }[],
    _dirName: string
  ): Observable<unknown> {
    throw new Error('Method not implemented.');
  }
}
